import React from "react"
import { KYCElement } from "@tap-payments/auth-jsconnect"
import { BankElement, IndividualElement, TaxElement, EntityElement, BrandElement, BoardElement, PasswordElement, TerminalElement } from "@tap-payments/auth-jsconnect"
import { useSearchParams } from "react-router-dom"
import { getDeploymentRegion } from "./utils"

export default function KYC() {
  const scope = "auth"
  const [token, setToken] = React.useState("")
  const [name, setName] = React.useState<"kyc" | "board" | "brand" | "tax" | "bank" | "individual" | "entity" | "password" | "terminal">("kyc")
  const [boardId, setBoardId] = React.useState("")
  const [searchParams] = useSearchParams()

  const countryCode = searchParams.get("country_code")
  const [busCountryCode, setBusCountryCode] = React.useState(countryCode ?? "")
  const region = getDeploymentRegion()

  const onBoardButtonClick = (item: any) => {
    setToken(item.token)
    setName(item.name)
    if (item.countryCode) setBusCountryCode(item.countryCode)
  }

  if (name === "brand") {
    return (
      <BrandElement
        open={true}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "tax") {
    return (
      <TaxElement
        open={true}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "bank") {
    return (
      <BankElement
        open={true}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "individual") {
    return (
      <IndividualElement
        open={true}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "entity") {
    return (
      <EntityElement
        open={true}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "password") {
    return (
      <PasswordElement
        open={true}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }

  if (name === 'terminal') {
      return (
        <TerminalElement
         open={true}
          scope='merchant'
          merchantDomain={window.location.origin}
          publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
          appInfo={{
            name: "Tap Connect Demo"
          }}
          businessCountryCode={""}
          language={"en" as any}
          onError={(error: any) => {
            console.log(JSON.stringify({ error }))
          }}
          onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
          verifyToken={token}
          onBoardButtonClick={onBoardButtonClick}
          region={region}
        />
      )
    }

  if (name === "board") {
    return (
      <BoardElement
        configToken={""}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        boardId={boardId || ""}
        disableSettingFetching={!!boardId}
        merchantDomain={window.location.origin}
        open={true}
        publicKey='pk_test_lat64TEDSvHrUOYAxVRe28PQ'
        scope='merchant'
        onError={(error: any) => console.log("error", JSON.stringify({ error }))}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", JSON.stringify(res))}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        onBoardCompleted={() => console.log("onBoardCompleted")}
        onReady={() => console.log("onReady")}
        onStepCompleted={(name, data) => console.log("onStepCompleted", name, data)}
        region={region}
      />
    )
  }

  return (
    <KYCElement
      open={true}
      mode={"page"}
      scope={scope}
      merchantDomain={window.location.origin}
      publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
      appInfo={{
        name: "Tap Connect Demo"
      }}
      language={"en" as any}
      onError={(error: any) => {
        console.log(JSON.stringify({ error }))
      }}
      onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
      onSwitchToBoard={(boardId: string) => {
        setBoardId(boardId)
        setName("board")
      }}
      businessCountryCode={busCountryCode ?? "SA"}
      onBoardButtonClick={onBoardButtonClick}
      region={region}
    />
  )
}
